import { render, staticRenderFns } from "./FinanceTaxInvoice.vue?vue&type=template&id=f20c1fda&scoped=true"
import script from "./FinanceTaxInvoice.vue?vue&type=script&lang=js"
export * from "./FinanceTaxInvoice.vue?vue&type=script&lang=js"
import style0 from "./FinanceTaxInvoice.vue?vue&type=style&index=0&id=f20c1fda&prod&scoped=true&lang=css"
import style1 from "./FinanceTaxInvoice.vue?vue&type=style&index=1&id=f20c1fda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20c1fda",
  null
  
)

export default component.exports